// Waste catalog options and "request a missing waste type".

import type { CatalogChangeRequestPayload } from '../../types/waste-catalog.type';
import { parseQueryParam } from '../core';
import { basketMaterialIds, buildCatalogOptions, createChangeRequest, fail, requireOrganization } from '../data';
import { bodyOf, ok, routes } from './helpers';

export const catalogRoutes = routes([
  [
    'get',
    '/waste-catalog/options',
    (ctx) => {
      // Scoped to the organization's basket when one is named (pickers), the
      // whole published catalog otherwise (the Materials page chooses from it).
      const orgId = parseQueryParam(ctx, 'organization_id');
      if (!orgId) return ok(buildCatalogOptions());
      requireOrganization(orgId);
      return ok(buildCatalogOptions(basketMaterialIds(orgId)));
    },
  ],
  [
    'post',
    '/waste-catalog/change-requests',
    (ctx) => {
      const body = bodyOf<CatalogChangeRequestPayload>(ctx);
      if (!body.organization_id) fail(422, 'organization_id is required');
      if (!body.description || !String(body.description).trim()) fail(422, 'Describe the waste type you need');
      const row = createChangeRequest({
        organization_id: String(body.organization_id),
        description: String(body.description).trim(),
        requested_name_en: body.requested_name_en,
        requested_name_ar: body.requested_name_ar,
        collection_site_id: body.collection_site_id,
        suggested_category_id: body.suggested_category_id,
        evidence: body.evidence,
        data: body.data,
      });
      return ok(row);
    },
  ],
]);
